var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Headline'),_c('Navigation'),_c('router-view'),_c('Footer'),_c('modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModalVisible),expression:"isModalVisible"}],on:{"close":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }